import client from './client'
import type { SuperAdmin, LoginPayload, LoginResponse } from '@/types/auth'

export async function login(payload: LoginPayload): Promise<LoginResponse> {
  const { data } = await client.post<LoginResponse>('/admin/auth/login', payload)
  return data
}

export async function fetchCurrentSuperAdmin(): Promise<SuperAdmin> {
  const { data } = await client.get<{ data: SuperAdmin }>('/admin/auth/user')
  return data.data
}

export async function logout(): Promise<void> {
  await client.post('/admin/auth/logout')
}
